<template>
  <div class="home">
    <div class="mainBox">
      <div class="header">
        <!-- <img class="ico1" height="110" :src="dagang"/> -->
        <!-- <img class="ico2" height="110" :src="providerLogo"/> -->
        <!-- <vs-button color="primary" type="relief">UNIVERSITY ENROLLS</vs-button> -->
      </div>
      <div class="body">
        <div class="textBox">
          <div class="titles">
            <h1 class="title">eScroll for</h1>
            <h1 class="title2">Educational Institution</h1>
            <img class="title3" :src="eScroll"/>
            <h1 class="title4">for Educational Institution</h1>
          </div>
          <h1 class="description">Authenticate your degree using<br>Blockchain Technology</h1>
          <vs-button class="trueBtn" color="primary" style="background-color: #2f8ed2;" type="relief" @click="verify = true">SCAN NOW</vs-button>
          <img :src="backimage" class="backImage"/>
          <!-- DOPPLEGANGERS -->
          <img class="reversePic" :src="backimage"/>
          <vs-button class="reverseBtn" color="primary" type="relief" @click="verify = true">SCAN NOW</vs-button>
        </div>
        <!-- <img class="luxtagImage" :src="luxtag"/> -->
      </div>
    </div>
    <div class="universityBox">
      <div class="carousel">
        <!-- <button class="arrowBtns" style="left: 60px;" @click="plusDivs(-1)">&#10094;</button> -->
        <div class="group">
          <!-- <img class="uum" :src="uum"/>
          <img class="mmu" :src="mmu"/> -->
          <img class="ico2" height="110" :src="providerLogo"/>
        </div>
        <!-- <div class="group">
          <img class="utm" :src="utm"/>
          <img class="binary" :src="binary"/>
        </div> -->
        <!-- <button class="arrowBtns" style="right: 60px;" @click="plusDivs(+1)">&#10095;</button> -->
      </div>
    </div>
    <div class="descriptionBox">
      <h1 class="why">Why eScroll?</h1>
      <span class="explain">Unlike the traditional paper-based documents which can be forged, eScroll has a unique signature and time-stamped certificate.</span>
      <h1 class="coming">Coming Soon!</h1>
      <!-- <span class="download">Download Now</span> -->
      <div class="downloadPics">
        <img :src="app"/>
        <img :src="google"/>
      </div>
      <img class="wave" :src="wave"/>
    </div>
    <!-- <verifier :scanning.sync="verify"></verifier> -->
    <verifier :open.sync="verify"></verifier>
  </div>
</template>

<script>
// @ is an alias to /src
import dagang from '@/assets/logo-dagang-net.png'
import providerLogo from '@/assets/providerLogo_Luxtag.png'
import eScroll from '@/assets/dagang-net-escroll-1@2x.png'
import backimage from '@/assets/graphic-top.png'
import luxtag from '@/assets/logo-luxtag-powerby.png'
import uum from '@/assets/logouum.png'
import mmu from '@/assets/mmulogo.png'
import utm from '@/assets/1111170120-logo.png'
import binary from '@/assets/bu-logo-website-01.png'
import app from '@/assets/apps-store-button-3-x.png'
import google from '@/assets/google-play-button-3-x.png'
import wave from '@/assets/wave.png'
import Verifier from '@/components/Verifier'
// import { setInterval } from 'timers'

export default {
  name: 'home',
  data () {
    return {
      dagang,
      providerLogo,
      eScroll,
      backimage,
      luxtag,
      uum,
      mmu,
      utm,
      binary,
      app,
      google,
      wave,
      carouselIndex: 0,
      carouselGroups: 0,
      verify: false
    }
  },
  created () {
    // setInterval(() => {
    //   this.verify = false
    // }, 1000)
  },
  // beforeRouteLeave (to, from, next) {
  //   console.log('Leaving')
  //   next()
  // },
  methods: {
    plusDivs (n) {
      this.showDivs(this.carouselIndex += n)
    },
    showDivs (n) {
      var width
      // var height
      if (window.outerHeight) {
        width = window.outerWidth
        // height = window.outerHeight
      } else {
        width = document.body.clientWidth
        // height = document.body.clientHeight
      }
      if (width <= 425) {
        var i
        var x = document.getElementsByClassName('group')
        if (n > x.length) {
          this.carouselIndex = 1
        }
        if (n < 1) {
          this.carouselIndex = x.length
        }
        for (i = 0; i < x.length; i++) {
          x[i].style.display = 'none'
        }
        x[this.carouselIndex - 1].style.display = 'flex'
      }
    },
    log (val) {
      console.log(val)
    }
  },
  components: {
    Verifier
  }
}
</script>
<style lang="scss">
  header div.con-title-after h3 {
    color: black !important;
  }
  .mainBox {
    display: flex;
    flex-direction: column;
    background-color: ghostwhite !important;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 40px 40px 40px 40px;
      @media screen and (max-width: 768px) {
        // justify-content: center;
      }
      @media screen and (max-width: 425px) {
        justify-content: center;
        padding: 12px 40px 20px 40px;
      }
      button {
        border-radius: 40px;
        padding: 10px 20px 10px 20px;
        span {
          font-size: 14px;
          font-weight: bold;
          line-height: 1.6;
          text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        }
        @media screen and (max-width: 375px) {
          padding: 5px 10px 5px 10px;
          span {
            font-size: 13px;
          }
        }
        @media screen and (max-width: 320px) {
          padding: 4px 8px 4px 8px;
          span {
            font-size: 10px;
          }
        }
      }
      .ico1 {
        display: none;
        @media screen and (max-width: 768px) {
          display: flex;
        }
        @media screen and (max-width: 425px) {
          display: none;
        }
      }
      .ico2 {
        display: flex;
        // @media screen and (max-width: 768px) {
          // display: none;
        // }
        @media screen and (max-width: 425px) {
          // display: flex;
          height: 80px;
        }
      }
    }
    .body {
      z-index: 1;
      .textBox {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        height: 540px;
        padding-left: 80px;
        @media screen and (max-width: 768px) {
          padding-left: 0px;
          height: auto;
          padding-bottom: 40px;
          justify-content: center;
          align-items: center;
        }
        .reverseBtn {
          display: none;
          padding: 10px 30px;
          span {
            font-size: 16px;
          }
          @media screen and (max-width: 768px) {
            display: flex;
          }
          @media screen and (max-width: 425px) {
            margin-top: 20px;
            span {
              font-size: 20px;
            }
          }
        }
        .reversePic {
          display: none;
          margin-top: 20px;
          width: 450px;
          @media screen and (max-width: 768px) {
            display: flex;
          }
          @media screen and (max-width: 425px) {
            width: 400px;
          }
          @media screen and (max-width: 375px) {
            width: 300px;
          }
        }
        .trueBtn {
          display: flex;
          @media screen and (max-width: 768px) {
            display: none;
          }
        }
        .titles {
          padding-top: 80px;
          display: flex;
          flex-direction: column;
          @media screen and (max-width: 768px) {
            // flex-direction: row;
            padding-top: 0px;
          }
          .title {
            color: #feb80c;
            font-size: 64px;
            line-height: 1.22;
            height: 60px;
            text-shadow: 0 3px 3px rgba(0, 0, 0, 0.16);
            display: none;
            @media screen and (max-width: 768px) {
              font-size: 43px;
              // display: flex;
            }
            @media screen and (max-width: 425px) {
              height: 45px;
              font-size: 30px;
            }
          }
          .title2 {
            color: #e6242b;
            font-size: 67px;
            line-height: 1.19;
            text-shadow: 0 3px 3px rgba(0, 0, 0, 0.16);
            display: none;
            @media screen and (max-width: 768px) {
              // display: flex;
              font-size: 43px;
              margin-left: 12px;
            }
            @media screen and (max-width: 425px) {
              height: 45px;
              font-size: 30px;
              margin-left: 8px;
            }
          }
          .title3 {
            display: flex;
            width: 240px;
            @media screen and (max-width: 768px) {
              // display: none;
              align-self: center;
              width: 210px;
            }
            @media screen and (max-width: 425px) {
              width: 150px;
            }
          }
          .title4 {
            color: #000;
            font-size: 34px;
            line-height: 1.19;
            text-shadow: 0 3px 3px rgba(0, 0, 0, 0.16);
            @media screen and (max-width: 768px) {
              // display: none;
              font-size: 42px;
            }
            @media screen and (max-width: 425px) {
              font-size: 28px;
              margin-bottom: 6px;
            }
          }
        }
        .description {
          line-height: 1.13;
          font-size: 24px;
          font-weight: normal;
          text-align: left;
          @media screen and (max-width: 768px) {
            color: #586871;
            text-align: center;
          }
          @media screen and (max-width: 425px) {
            font-size: 18px;
          }
        }
        button {
          display: flex;
          margin-top: 40px;
          border-radius: 40px;
          padding: 10px 20px;
          span {
            font-size: 14px;
            font-weight: bold;
            line-height: 1.6;
            text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
          }
        }
      }
      .backImage {
        display: flex;
        z-index: -1;
        height: 450px;
        position: absolute;
        right: 0;
        margin-right: 60px;
        @media screen and (min-width: 1440px) {
          height: 680px;
          top: 25px;
        }
        @media screen and (max-width: 768px) {
          display: none;
          // z-index: 1;
          // position: relative;
          // right: auto;
          // margin-right: 0px;
          // margin-top: 20px;
        }
      }
      .luxtagImage {
        display: flex;
        float: right;
        margin: 20px 20px 20px 20px
      }
    }
  }
  .universityBox {
    .carousel {
      display: flex;
      margin-top: 40px;
      margin-bottom: 40px;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      padding: 20px;
      @media screen and (max-width: 425px) {
        flex-direction: column;
      }
      .ico2 {
        display: flex;
        // @media screen and (max-width: 768px) {
          // display: none;
        // }
        @media screen and (max-width: 425px) {
          // display: flex;
          height: 80px;
        }
      }
      .group {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
      }
      img {
        padding: 0px 10px 0 10px;
      }
      .arrowBtns {
        display: flex;
        position: absolute;
        font-size: 20px;
        width: 40px;
        height: 40px;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        border: 0px;
        cursor: pointer;
        color: #c0c0c0;
      }
      @media screen and (max-width: 768px) {
        .uum {
          height: 40px;
        }
        .mmu {
          height: 32px;
        }
        .utm {
          height: 68px;
        }
        .binary {
          height: 68px;
        }
      }
      @media screen and (max-width: 545px) {
        .uum {
          height: 30px;
        }
        .mmu {
          height: 22px;
        }
        .utm {
          height: 58px;
          padding-right: 0px;
          margin-left: 10px;
        }
        .binary {
          height: 58px;
          padding-left: 0px;
          margin-left: 10px;
        }
      }
      @media screen and (max-width: 425px) {
        padding: 10px;
        .uum {
          height: 40px;
        }
        .mmu {
          height: 32px;
        }
        .utm {
          height: 68px;
        }
        .binary {
          height: 68px;
        }
      }
    }
  }
  .descriptionBox {
    display: flex;
    position: relative;
    color: #fff;
    background-color: #2f8ed2;
    padding: 60px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .why {
      font-size: 40px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 25px;
      }
      @media screen and (max-width: 425px) {
        font-size: 20px;
      }
    }
    .explain {
      font-size: 25px;
      max-width: 760px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 18px;
        max-width: 560px;
        margin-top: 10px;
      }
      @media screen and (max-width: 425px) {
        font-size: 14px;
      }
    }
    .coming {
      font-size: 30px;
      font-weight: bold;
      margin-top: 80px;
      @media screen and (max-width: 768px) {
        margin-top: 40px;
        font-size: 25px;
      }
      @media screen and (max-width: 425px) {
        font-size: 20px;
      }
    }
    .download {
      font-size: 18px;
      @media screen and (max-width: 425px) {
        font-size: 14px;
      }
    }
    .downloadPics {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      @media screen and (max-width: 768px) {
        margin-top: 10px;
      }
      @media screen and (max-width: 425px) {
        margin-top: 20px;
      }
      img {
        height: 50px;
        padding: 0px 10px 0px 10px;
        @media screen and (max-width: 768px) {
          height: 70px;
        }
        @media screen and (max-width: 425px) {
          height: 50px;
        }
        @media screen and (max-width: 320px) {
          height: 45px;
        }
      }
    }
    .wave {
      display: flex;
      z-index: 1;
      position: absolute;
      width: 100%;
      bottom: 0px;
    }
  }
</style>
